import {graffitiConstants} from "./graffiti.constants";
import {graffitiService} from "./graffiti.service";
import {toastHelper} from "../../utils/toast-helper";

export const graffitiActions = {
    fetchCommunes,
    fetchQuartiers,
    fetchRues,
    fetchMetadata,
    fetchCommuneFeature,
    fetchQuartierFeature,
    fetchRueFeature,
    clearData,
};

function fetchCommunes(clientId) {
    return dispatch => {
        dispatch(request());

        graffitiService.fetchCommunes(clientId)
            .then(
                data => {
                    dispatch(success(data));
                },
                error => {
                    dispatch(failure(error.toString()));
                    toastHelper.error("Erreur lors du chargement des communes");
                }
            );
    };

    function request() {
        return {type: graffitiConstants.GRAFFITI_COMMUNES_FETCH_REQUEST}
    }

    function success(communes) {
        return {type: graffitiConstants.GRAFFITI_COMMUNES_FETCH_SUCCESS, communes}
    }

    function failure(error) {
        return {type: graffitiConstants.GRAFFITI_COMMUNES_FETCH_FAILURE, error}
    }
}

function fetchQuartiers(clientId) {
    return dispatch => {
        dispatch(request());

        graffitiService.fetchQuartiers(clientId)
            .then(
                data => {
                    dispatch(success(data));
                },
                error => {
                    dispatch(failure(error.toString()));
                    toastHelper.error("Erreur lors du chargement des quartiers");
                }
            );
    };

    function request() {
        return {type: graffitiConstants.GRAFFITI_QUARTIERS_FETCH_REQUEST}
    }

    function success(quartiers) {
        return {type: graffitiConstants.GRAFFITI_QUARTIERS_FETCH_SUCCESS, quartiers}
    }

    function failure(error) {
        return {type: graffitiConstants.GRAFFITI_QUARTIERS_FETCH_FAILURE, error}
    }
}

function fetchRues(clientId) {
    return dispatch => {
        dispatch(request());

        graffitiService.fetchRues(clientId)
            .then(
                data => {
                    dispatch(success(data));
                },
                error => {
                    dispatch(failure(error.toString()));
                    toastHelper.error("Erreur lors du chargement des rues");
                }
            );
    };

    function request() {
        return {type: graffitiConstants.GRAFFITI_RUES_FETCH_REQUEST}
    }

    function success(rues) {
        return {type: graffitiConstants.GRAFFITI_RUES_FETCH_SUCCESS, rues}
    }

    function failure(error) {
        return {type: graffitiConstants.GRAFFITI_RUES_FETCH_FAILURE, error}
    }
}

function fetchMetadata(clientId) {
    return dispatch => {
        dispatch(request());

        graffitiService.fetchMetadata(clientId)
            .then(
                data => {
                    dispatch(success(data));
                },
                error => {
                    dispatch(failure(error.toString()));
                    toastHelper.error("Erreur lors du chargement des métadonnées");
                }
            );
    };

    function request() {
        return {type: graffitiConstants.GRAFFITI_METADATA_FETCH_REQUEST}
    }

    function success(metadata) {
        return {type: graffitiConstants.GRAFFITI_METADATA_FETCH_SUCCESS, metadata}
    }

    function failure(error) {
        return {type: graffitiConstants.GRAFFITI_METADATA_FETCH_FAILURE, error}
    }
}

function clearData() {
    return {type: graffitiConstants.GRAFFITI_CLEAR_REQUEST}
}

function fetchCommuneFeature(clientId, id) {
    return (dispatch, getState) => {
        // cache check: if already present, skip
        const existing = getState()?.graffiti?.communeFeaturesById?.[id];
        if (existing) return Promise.resolve(existing);
        dispatch({ type: graffitiConstants.GRAFFITI_COMMUNE_FEATURE_FETCH_REQUEST, id });
        return graffitiService.fetchCommuneFeature(clientId, id)
            .then(
                feature => {
                    dispatch({ type: graffitiConstants.GRAFFITI_COMMUNE_FEATURE_FETCH_SUCCESS, id, feature });
                    return feature;
                },
                error => {
                    dispatch({ type: graffitiConstants.GRAFFITI_COMMUNE_FEATURE_FETCH_FAILURE, id, error: error.toString() });
                }
            );
    }
}

function fetchQuartierFeature(clientId, id) {
    return (dispatch, getState) => {
        const existing = getState()?.graffiti?.quartierFeaturesById?.[id];
        if (existing) return Promise.resolve(existing);
        dispatch({ type: graffitiConstants.GRAFFITI_QUARTIER_FEATURE_FETCH_REQUEST, id });
        return graffitiService.fetchQuartierFeature(clientId, id)
            .then(
                feature => {
                    dispatch({ type: graffitiConstants.GRAFFITI_QUARTIER_FEATURE_FETCH_SUCCESS, id, feature });
                    return feature;
                },
                error => {
                    dispatch({ type: graffitiConstants.GRAFFITI_QUARTIER_FEATURE_FETCH_FAILURE, id, error: error.toString() });
                }
            );
    }
}

function fetchRueFeature(clientId, id) {
    return (dispatch, getState) => {
        const existing = getState()?.graffiti?.rueFeaturesById?.[id];
        if (existing) return Promise.resolve(existing);
        dispatch({ type: graffitiConstants.GRAFFITI_RUE_FEATURE_FETCH_REQUEST, id });
        return graffitiService.fetchRueFeature(clientId, id)
            .then(
                feature => {
                    dispatch({ type: graffitiConstants.GRAFFITI_RUE_FEATURE_FETCH_SUCCESS, id, feature });
                    return feature;
                },
                error => {
                    dispatch({ type: graffitiConstants.GRAFFITI_RUE_FEATURE_FETCH_FAILURE, id, error: error.toString() });
                }
            );
    }
}